<div class="container-fluid">
  <ng-template [ngIf]="employmentForm">
    <div class="row mt-2">
      <div class="col-12">
        <form [formGroup]="employmentForm" (ngSubmit)="onSubmit()">
          <div class="row">
            <div class="col-12">
              <h5 class="text-primary">Informations travailleur</h5>
            </div>
          </div>
          <div class="row">
            <div class="mb-3 text-secondary col-12 col-lg-12 col-xl-6">
              <label>Type d'emploi recherché</label>
              <select class="form-select" formControlName="wantedJobTypeId">
                <option value="" hidden></option>
                <option *ngFor="let jobType of jobTypes" [ngValue]="jobType.id">
                  {{ jobType.label }}
                </option>
              </select>
            </div>
          </div>
          <!-- Entrepreneur -->
          <div class="row">
            <div class="mb-3 text-secondary col-12 col-lg-12 col-xl-6">
              <label class="required">Entrepreneur</label>
              <div class="mb-3 text-secondary">
                <div class="row justify-content-start my-2">
                  <div class="col-2">
                    <div class="form-check form-check-inline">
                      <input
                        id="no"
                        type="radio"
                        class="form-check-input"
                        formControlName="entrepreneur"
                        name="entrepreneur"
                        value="No"
                        [class.is-invalid]="submitted && employmentForm.controls?.entrepreneur?.invalid"
                      />
                      <label for="no" class="form-check-label">Non</label>
                    </div>
                  </div>
                  <div class="col-4">
                    <div class="form-check form-check-inline">
                      <input
                        id="businessOwner"
                        type="radio"
                        class="form-check-input"
                        formControlName="entrepreneur"
                        name="entrepreneur"
                        value="BusinessOwner"
                        [class.is-invalid]="submitted && employmentForm.controls?.entrepreneur?.invalid"
                      />
                      <label for="businessOwner" class="form-check-label">Chef d'entreprise</label>
                    </div>
                  </div>
                  <div class="col-5">
                    <div class="form-check form-check-inline">
                      <input
                        id="freelancer"
                        type="radio"
                        class="form-check-input"
                        formControlName="entrepreneur"
                        name="entrepreneur"
                        value="Freelancer"
                        [class.is-invalid]="submitted && employmentForm.controls?.entrepreneur?.invalid"
                      />
                      <label for="freelancer" class="form-check-label">Travailleur indépendant</label>
                    </div>
                  </div>
                </div>
                <small *ngIf="submitted && employmentForm.controls?.entrepreneur?.errors?.required" class="form-text text-danger"
                  >L'information entrepreneur est requise.</small
                >
              </div>
            </div>
          </div>
          <div class="row">
            <div class="mb-3 text-secondary col-12 col-lg-12 col-xl-3">
              <label>Début d'entrepreneuriat</label>
              <app-datepicker
                formControlName="beginDateEntrepreneurship"
                [invalid]="submitted && employmentForm.controls?.beginDateEntrepreneurship?.invalid"
              >
              </app-datepicker>
              <small *ngIf="submitted && employmentForm.controls?.beginDateEntrepreneurship?.errors?.required" class="form-text text-danger"
                >La date de début d'entrepreneuriat est requise.</small
              >
              <small *ngIf="submitted && employmentForm.controls?.beginDateEntrepreneurship?.errors?.dateFormat" class="form-text text-danger"
                >La date de début d'entrepreneuriat est invalide.</small
              >
              <small *ngIf="submitted && employmentForm.errors?.datesOrder" class="form-text text-danger"
                >La date de fin est incohérente avec la date de début.</small
              >
            </div>
            <div class="mb-3 text-secondary col-12 col-lg-12 col-xl-3">
              <label>Fin d'entrepreneuriat</label>
              <app-datepicker
                formControlName="endDateEntrepreneurship"
                [invalid]="submitted && employmentForm.controls?.endDateEntrepreneurship?.invalid"
              >
              </app-datepicker>
              <small *ngIf="submitted && employmentForm.controls?.endDateEntrepreneurship?.errors?.dateFormat" class="form-text text-danger"
                >La date de fin d'entrepreneuriat est invalide.</small
              >
              <small *ngIf="submitted && employmentForm.errors?.datesOrder" class="form-text text-danger"
                >La date de fin est incohérente avec la date de début.</small
              >
            </div>
            <div class="mb-3 text-secondary col-12 col-lg-12 col-xl-6">
              <label>Type d'activité</label>
              <div class="mb-3 text-secondary">
                <select class="form-select" formControlName="sectorId" [class.is-invalid]="submitted && employmentForm.controls.sectorId.invalid">
                  <option *ngFor="let sector of sectors" [ngValue]="sector.id">
                    {{ sector.label }}
                  </option>
                </select>
                <small *ngIf="submitted && employmentForm.get('sectorId').hasError('required')" class="form-text text-danger"
                  >Le type d'activité est requis.</small
                >
              </div>
            </div>
            <div class="mb-3 text-secondary col-12 col-lg-12 col-xl-3">
              <label class="required">Niveau d'étude initial</label>
              <div class="mb-3 text-secondary">
                <select class="form-select" formControlName="degreeId" [class.is-invalid]="submitted && employmentForm.controls.degreeId.invalid">
                  <option *ngFor="let degree of degrees" [ngValue]="degree.id">
                    {{ degree.label }}
                  </option>
                </select>
                <small *ngIf="submitted && employmentForm.get('degreeId').hasError('required')" class="form-text text-danger"
                  >Le niveau d'étude initial est requis.</small
                >
              </div>
            </div>
            <!-- Étude à l'étranger -->
            <div class="mb-3 text-secondary col-6 col-lg-6 col-xl-3">
              <label class="required">Étude à l'étranger</label>
              <div class="mb-3 text-secondary">
                <div class="row justify-content-start my-2">
                  <div class="col-3">
                    <div class="form-check form-check-inline">
                      <input
                        id="sYes"
                        type="radio"
                        class="form-check-input"
                        formControlName="studyAbroad"
                        name="studyAbroad"
                        [class.is-invalid]="submitted && employmentForm.controls.studyAbroad.invalid"
                        [value]="true"
                      />
                      <label for="sYes" class="form-check-label">Oui</label>
                    </div>
                  </div>
                  <div class="col-3">
                    <div class="form-check form-check-inline">
                      <input
                        id="sNo"
                        type="radio"
                        class="form-check-input"
                        formControlName="studyAbroad"
                        name="studyAbroad"
                        [class.is-invalid]="submitted && employmentForm.controls.studyAbroad.invalid"
                        [value]="false"
                      />
                      <label for="sNo" class="form-check-label">Non</label>
                    </div>
                  </div>
                </div>
                <small *ngIf="submitted && employmentForm.controls?.studyAbroad?.errors?.required" class="form-text text-danger"
                  >Étude à l'étranger est requise.</small
                >
              </div>
            </div>
            <div class="mb-3 text-secondary col-12 col-lg-12 col-xl-6">
              <label>Domaines de formation</label>
              <div class="mb-3 text-secondary">
                <ng-select
                  formControlName="trainingAreaIds"
                  [items]="trainingAreas"
                  bindValue="id"
                  bindLabel="label"
                  [multiple]="true"
                  [closeOnSelect]="false"
                ></ng-select>
              </div>
            </div>
          </div>
          <div class="row">
            <!-- Agrément SIAE -->
            <div class="mb-3 text-secondary col-6 col-lg-6 col-xl-3">
              <label class="required">Agrément SIAE</label>
              <div class="mb-3 text-secondary">
                <div class="row justify-content-start my-2">
                  <div class="col-3">
                    <div class="form-check form-check-inline">
                      <input
                        id="aYes"
                        type="radio"
                        class="form-check-input"
                        formControlName="accreditationSIAE"
                        (change)="resetValidatorSIAE()"
                        name="accreditationSIAE"
                        [class.is-invalid]="submitted && employmentForm.controls.accreditationSIAE.invalid"
                        [value]="true"
                      />
                      <label for="aYes" class="form-check-label">Oui</label>
                    </div>
                  </div>
                  <div class="col-3">
                    <div class="form-check form-check-inline">
                      <input
                        id="aNo"
                        type="radio"
                        class="form-check-input"
                        formControlName="accreditationSIAE"
                        name="accreditationSIAE"
                        [class.is-invalid]="submitted && employmentForm.controls.accreditationSIAE.invalid"
                        [value]="false"
                      />
                      <label for="aNo" class="form-check-label">Non</label>
                    </div>
                  </div>
                </div>
                <small *ngIf="submitted && employmentForm.controls?.accreditationSIAE?.errors?.required" class="form-text text-danger"
                  >SIAE est requis.</small
                >
              </div>
            </div>
            <div class="mb-3 text-secondary col-6 col-lg-6 col-xl-3">
              <label>Fin d'agrément SIAE</label>
              <app-datepicker
                formControlName="accreditationSIAEDate"
                [invalid]="submitted && employmentForm.controls?.accreditationSIAEDate?.invalid"
              >
              </app-datepicker>
              <small *ngIf="submitted && employmentForm.controls?.accreditationSIAEDate?.errors?.required" class="form-text text-danger"
                >La date d'agrément SIAE est requise.</small
              >
              <small *ngIf="submitted && employmentForm.controls?.accreditationSIAEDate?.errors?.dateFormat" class="form-text text-danger"
                >La date d'agrément SIAE est invalide.</small
              >
            </div>
          </div>
          <div class="row">
            <!-- RQTH -->
            <div class="mb-3 text-secondary col-12 col-lg-12 col-xl-3">
              <label class="required">RQTH</label>
              <div class="mb-3 text-secondary">
                <div class="row justify-content-start align-items-center my-2">
                  <div class="col-3">
                    <div class="form-check form-check-inline">
                      <input
                        id="rYes"
                        type="radio"
                        class="form-check-input"
                        formControlName="rqth"
                        (change)="resetValidatorRQTH()"
                        name="rqth"
                        [class.is-invalid]="submitted && employmentForm.controls.rqth.invalid"
                        [value]="true"
                      />
                      <label for="rYes" class="form-check-label">Oui</label>
                    </div>
                  </div>
                  <div class="col-3">
                    <div class="form-check form-check-inline">
                      <input
                        id="rNo"
                        type="radio"
                        class="form-check-input"
                        formControlName="rqth"
                        name="rqth"
                        [class.is-invalid]="submitted && employmentForm.controls.rqth.invalid"
                        [value]="false"
                      />
                      <label for="rNo" class="form-check-label">Non</label>
                    </div>
                  </div>
                </div>
                <small *ngIf="submitted && employmentForm.controls?.rqth?.errors?.required" class="form-text text-danger">RQTH est requis.</small>
              </div>
            </div>
            <div class="mb-3 text-secondary col-12 col-lg-12 col-xl-3">
              <label>Fin de validité RQTH</label>
              <app-datepicker formControlName="expiryRqthDate" [invalid]="submitted && employmentForm.controls?.expiryRqthDate?.invalid">
              </app-datepicker>
              <small *ngIf="submitted && employmentForm.controls?.expiryRqthDate?.errors?.required" class="form-text text-danger"
                >La date de fin de validité RQTH est requise.</small
              >
              <small *ngIf="submitted && employmentForm.controls?.expiryRqthDate?.errors?.dateFormat" class="form-text text-danger"
                >La date de fin de validité RQTH est invalide.</small
              >
            </div>
          </div>
        </form>
      </div>
    </div>
  </ng-template>
  <div class="mt-2">
    <app-dynamic-form
      #qualificationsComponent
      [title]="'Informations qualifications'"
      [noGroupText]="'Il n\'y aucune qualification renseignée. Cliquer sur le bouton + pour en ajouter.'"
      [data]="employmentQualifications"
      [fields]="qualificationFields"
    >
      <ng-template #qualificationRow let-groupIndex="groupIndex" let-group="group" let-groupRemoved="groupRemoved">
        <div class="text-secondary col-12 col-lg-12 col-xl-3 mb-2" [formGroup]="group">
          <label [class.d-xl-none]="groupIndex !== 0" class="required">Date d'obtention</label>
          <app-datepicker formControlName="qualificationDate" [invalid]="submitted && group.controls?.qualificationDate?.invalid"></app-datepicker>
          <small *ngIf="submitted && group.controls?.qualificationDate?.errors?.required" class="form-text text-danger"
            >La date d'obtention est requise.</small
          >
        </div>
        <div class="text-secondary col-12 col-lg-12 col-xl-3 mb-2" [formGroup]="group">
          <label [class.d-xl-none]="groupIndex !== 0" class="required">Type</label>
          <select
            class="form-select"
            formControlName="qualificationTypeId"
            [class.is-invalid]="submitted && group.controls?.qualificationTypeId?.errors?.required"
          >
            <option value="" disabled></option>
            <option *ngFor="let option of qualificationTypes" [ngValue]="option.id">
              {{ option.label }}
            </option>
          </select>
          <small *ngIf="submitted && group.controls?.qualificationTypeId?.errors?.required" class="form-text text-danger">Le type est requis.</small>
        </div>
        <div class="text-secondary col-12 col-lg-12 col-xl-6 mb-2" [formGroup]="group">
          <label [class.d-xl-none]="groupIndex !== 0">Description</label>
          <div class="input-group">
            <input type="text" class="form-control me-3 rounded" formControlName="qualificationDesc" />
            <button type="button" ngbTooltip="Supprimer" placement="left" class="btn btn-outline-primary rounded" (click)="groupRemoved(groupIndex)">
              <fa-icon icon="trash-alt"></fa-icon>
            </button>
          </div>
        </div>
      </ng-template>
    </app-dynamic-form>
  </div>
  <div class="mt-2">
    <app-dynamic-form
      #transportsComponent
      [title]="'Moyens de transport'"
      [data]="employmentTransportModes"
      [fields]="transportModeFields"
      [noGroupText]="'Il n\'y aucun moyen de transport renseigné. Cliquer sur le bouton + pour en ajouter.'"
    >
      <ng-template #transportModeRow let-groupIndex="groupIndex" let-group="group" let-groupRemoved="groupRemoved">
        <div class="text-secondary col-12 col-lg-12 col-xl-3 mb-2" [formGroup]="group">
          <label [class.d-xl-none]="groupIndex !== 0" class="required">Moyen de transport</label>
          <select
            class="form-select"
            formControlName="transportModeId"
            [class.is-invalid]="submitted && group.controls?.transportModeId?.errors?.required"
          >
            <option value="" disabled></option>
            <option *ngFor="let option of transportModes" [ngValue]="option.id">{{ option.label }}</option>
          </select>
          <small *ngIf="submitted && group.controls?.transportModeId?.errors?.required" class="form-text text-danger"
            >Le moyen de transport est requis.</small
          >
        </div>
        <div class="text-secondary col-12 col-lg-12 col-xl-9 mb-2" [formGroup]="group">
          <label [class.d-xl-none]="groupIndex !== 0">Description</label>
          <div class="input-group">
            <input type="text" class="form-control me-3 rounded" formControlName="description" />
            <button type="button" ngbTooltip="Supprimer" placement="left" class="btn btn-outline-primary rounded" (click)="groupRemoved(groupIndex)">
              <fa-icon icon="trash-alt"></fa-icon>
            </button>
          </div>
        </div>
      </ng-template>
    </app-dynamic-form>
  </div>
  <div class="mt-2">
    <app-dynamic-form
      #barriersComponent
      [title]="'Freins à l\'emploi'"
      [data]="employmentBarriers"
      [fields]="barrierFields"
      [noGroupText]="'Il n\'y aucun frein à l\'emploi renseigné. Cliquer sur le bouton + pour en ajouter.'"
    >
      <ng-template #barrierRow let-groupIndex="groupIndex" let-group="group" let-groupRemoved="groupRemoved">
        <div class="text-secondary col-12 col-lg-12 col-xl-4 mb-2" [formGroup]="group">
          <label [class.d-xl-none]="groupIndex !== 0" class="required">Frein à l'emploi</label>
          <select class="form-select" formControlName="barrierId" [class.is-invalid]="submitted && group.controls?.barrierId?.errors?.required">
            <option value="" disabled></option>
            <option *ngFor="let option of barriers" [ngValue]="option.id">{{ option.label }}</option>
          </select>
          <small *ngIf="submitted && group.controls?.barrierId?.errors?.required" class="form-text text-danger"
            >Le frein à l'emploi est requis.</small
          >
        </div>
        <div class="text-secondary col-12 col-lg-12 col-xl-5 mb-2" [formGroup]="group">
          <label [class.d-xl-none]="groupIndex !== 0">Description</label>
          <div class="input-group">
            <input type="text" class="form-control" formControlName="description" />
          </div>
        </div>
        <div class="text-secondary col-12 col-lg-12 col-xl-3 mb-2" [formGroup]="group">
          <label [class.d-xl-none]="groupIndex !== 0" class="required">Statut du frein</label>
          <div class="input-group">
            <select
              class="form-select me-3 rounded"
              formControlName="barrierStatus"
              [class.is-invalid]="submitted && group.controls?.barrierStatus?.errors?.required"
            >
              <option value="" disabled></option>
              <option *ngFor="let status of barrierStatuses | keyvalue: stringAscOrder" [ngValue]="status.key">
                {{ status.value }}
              </option>
            </select>

            <button type="button" ngbTooltip="Supprimer" placement="left" class="btn btn-outline-primary rounded" (click)="groupRemoved(groupIndex)">
              <fa-icon icon="trash-alt"></fa-icon>
            </button>
          </div>
          <small *ngIf="submitted && group.controls?.barrierStatus?.errors?.required" class="form-text text-danger"
            >Le statut du frein est requis.</small
          >
        </div>
      </ng-template>
    </app-dynamic-form>
  </div>
  <div class="mt-2">
    <app-dynamic-form
      #assetsComponent
      [title]="'Atouts'"
      [data]="employmentAssets"
      [fields]="assetFields"
      [noGroupText]="'Il n\'y aucun atout renseigné. Cliquer sur le bouton + pour en ajouter.'"
    >
      <ng-template #transportModeRow let-groupIndex="groupIndex" let-group="group" let-groupRemoved="groupRemoved">
        <div class="text-secondary col-12 col-lg-12 col-xl-3 mb-2" [formGroup]="group">
          <label [class.d-xl-none]="groupIndex !== 0" class="required">Atout</label>
          <select class="form-select" formControlName="assetId" [class.is-invalid]="submitted && group.controls?.assetId?.errors?.required">
            <option value="" disabled></option>
            <option *ngFor="let option of assets" [ngValue]="option.id">{{ option.label }}</option>
          </select>
          <small *ngIf="submitted && group.controls?.assetId?.errors?.required" class="form-text text-danger">L'atout est requis.</small>
        </div>
        <div class="text-secondary col-12 col-lg-12 col-xl-9 mb-2" [formGroup]="group">
          <label [class.d-xl-none]="groupIndex !== 0">Description</label>
          <div class="input-group">
            <input type="text" class="form-control me-3 rounded" formControlName="description" />
            <button type="button" ngbTooltip="Supprimer" placement="left" class="btn btn-outline-primary rounded" (click)="groupRemoved(groupIndex)">
              <fa-icon icon="trash-alt"></fa-icon>
            </button>
          </div>
        </div>
      </ng-template>
    </app-dynamic-form>
  </div>
  <div class="mt-2">
    <app-dynamic-form
      #jobsComponent
      [title]="'Informations métier'"
      [data]="employmentJobs"
      [fields]="jobFields"
      [noGroupText]="'Il n\'y aucun métier renseigné. Cliquer sur le bouton + pour en ajouter.'"
    >
      <ng-template #jobRow let-groupIndex="groupIndex" let-group="group" let-groupRemoved="groupRemoved">
        <div class="text-secondary col-12 col-lg-12 col-xl-4 mb-2" [formGroup]="group">
          <label [class.d-xl-none]="groupIndex !== 0" class="required">Famille</label>
          <select
            class="form-select"
            formControlName="sector"
            [class.is-invalid]="submitted && group.controls?.sector?.errors?.required"
            (change)="handleSectorChange(group)"
          >
            <option value="" hidden></option>
            <option *ngFor="let sector of sectors" [ngValue]="sector">{{ sector.label }}</option>
          </select>
          <small *ngIf="submitted && group.controls?.sector?.errors?.required" class="form-text text-danger">La famille est requise.</small>
        </div>
        <div class="text-secondary col-12 col-lg-12 col-xl-4 mb-2" [formGroup]="group">
          <label [class.d-xl-none]="groupIndex !== 0" class="required">Domaine professionnel</label>
          <select
            class="form-select"
            formControlName="domain"
            [attr.disabled]="group.controls?.sector?.value ? null : ''"
            [class.is-invalid]="submitted && group.controls?.domain?.errors?.required"
            (change)="handleDomainChange(group)"
          >
            <option value="" hidden></option>
            <option *ngFor="let domain of group.controls?.sector?.value?.subValues" [ngValue]="domain">
              {{ domain.label }}
            </option>
          </select>
          <small *ngIf="submitted && group.controls?.domain?.errors?.required" class="form-text text-danger">Le domaine est requis.</small>
        </div>
        <div class="text-secondary col-12 col-lg-12 col-xl-4 mb-2" [formGroup]="group">
          <label [class.d-xl-none]="groupIndex !== 0" class="required">Métier souhaité</label>
          <div class="input-group">
            <select
              class="form-select me-3 rounded"
              formControlName="job"
              [attr.disabled]="group.controls?.domain?.value ? null : ''"
              [class.is-invalid]="submitted && group.controls?.job?.errors?.required"
            >
              <option value="" hidden></option>
              <option *ngFor="let job of group.controls?.domain?.value?.subValues" [ngValue]="job">
                {{ job.label }}
              </option>
            </select>

            <button type="button" ngbTooltip="Supprimer" placement="left" class="btn btn-outline-primary rounded" (click)="groupRemoved(groupIndex)">
              <fa-icon icon="trash-alt"></fa-icon>
            </button>
          </div>
          <small *ngIf="submitted && group.controls?.job?.errors?.required" class="form-text text-danger">Le métier souhaité est requis.</small>
        </div>
      </ng-template>
    </app-dynamic-form>

    <div class="row mt-4 mb-3">
      <div class="d-grid ms-auto col-md-6 col-3 col-lg-3 col-xl-2 px-0" *appProfilePerimeter>
        <button
          class="btn btn-primary d-flex justify-content-center"
          type="button"
          (click)="cancel()"
          *appOnlyGroups="['ADMIN', 'STRUCTURE', 'DIRECTION+']"
        >
          <fa-icon icon="ban"></fa-icon>
          <span class="ms-2 d-none d-md-block">Annuler</span>
        </button>
      </div>
      <div class="d-grid col-3 col-md-6 col-lg-3 col-xl-2 pe-0" *appProfilePerimeter>
        <button
          class="btn btn-primary d-flex justify-content-center"
          type="button"
          (click)="onSubmit()"
          *appOnlyGroups="['ADMIN', 'STRUCTURE', 'DIRECTION+']"
        >
          <fa-icon icon="save"></fa-icon>
          <span class="ms-2 d-none d-md-block">Sauvegarder</span>
        </button>
      </div>
    </div>
  </div>
</div>
